import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface FaqItem {
  question: string;
  answer: string;
}
const FAQS: FaqItem[] = [{
  question: '¿Este sistema fue creado para profesores de pilates de Argentina?',
  answer: 'Sí. Todo el contenido fue desarrollado pensando en la realidad de los profesores y profesoras de pilates que trabajan en Argentina. Los ejemplos, casos y recursos están adaptados al contexto local, aunque también puede ser utilizado por profesionales de otros países de habla hispana.'
}, {
  question: '¿El producto es físico o digital?',
  answer: 'Es 100% digital. Una vez confirmada la compra vas a recibir acceso inmediato para descargar todo el material desde tu computadora, tablet o celular.'
}, {
  question: '¿Necesito experiencia para aprovechar el contenido?',
  answer: 'No. El sistema está pensado tanto para profesores que recién comienzan como para profesionales con experiencia que quieren organizar mejor sus clases, ahorrar tiempo y enseñar con mayor seguridad.'
}, {
  question: '¿Qué incluye mi compra?',
  answer: 'Recibirás acceso al Sistema Pilates Resuelto, compuesto por 5 módulos completos y 5 bonos exclusivos, con clases listas para usar, adaptaciones, recursos prácticos y herramientas para aplicar desde el primer día.'
}, {
  question: '¿Voy a tener acceso para siempre?',
  answer: 'Sí. El acceso es de por vida. Una vez realizada la compra podrás ingresar y consultar todo el contenido las veces que quieras, sin pagos mensuales ni renovaciones.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleItem = (index: number) => {
    setOpenIndex(currentIndex => currentIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-45" data-mp="3ucrfogwuugj3">
      <div className="mx-auto max-w-[900px] px-5 sm:px-6" data-id="element-46" data-mp="3uecbsayti7j2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-47" data-mp="1ya4w6v5rs2wt">
          <p className="inline-flex items-center gap-2 rounded-full border border-brown-light/25 bg-beige px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-48" data-mp="2386cx9fq3q54">
            <span className="h-1.5 w-1.5 rounded-full bg-brown-light" data-id="element-49" data-mp="289dm9cxikxdw" />
            Todo claro
          </p>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-50" data-mp="2c6jg961lnnrj">
            Preguntas Frecuentes
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-[#4A4A4A] sm:text-lg" data-id="element-51" data-mp="2m5r2yju84urb">
            Respondemos las dudas más comunes antes de que empieces a utilizar Pilates Resuelto.
          </p>
        </div>

        <div className="mt-11 space-y-4" data-id="element-52" data-mp="2vw2ashh13o3h">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          const contentId = `faq-answer-${index}`;
          return <article key={faq.question} className={`overflow-hidden rounded-xl border transition-colors duration-200 ${isOpen ? 'border-brown-light/35 bg-beige/45 shadow-sm' : 'border-brown-light/15 bg-white shadow-[0_3px_14px_rgba(94,67,50,0.04)]'}`} data-id="element-53" data-mp="34vgyxa9q3mkt" data-mpi={index}>
                <h3 data-id="element-54" data-mp="fbzwujt62gbw">
                  <button type="button" onClick={() => toggleItem(index)} aria-expanded={isOpen} aria-controls={contentId} className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left sm:px-7 sm:py-6" data-id="element-55" data-mp="fchyjvyllmr7">
                    <span className="font-serif text-lg font-semibold leading-snug text-brown-dark sm:text-xl" data-id="element-56" data-mp="y9sx1eceoc5l">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${isOpen ? 'bg-brown-dark text-white' : 'bg-beige-deep text-brown-light'}`} aria-hidden="true" data-id="element-57" data-mp="1qxym2dahsnb8">
                      {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-58" data-mp="16hvrlw33ao2t" /> : <PlusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-59" data-mp="1u7hpmg7q6x98" />}
                    </span>
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-60" data-mp="1kgvcqtre8ku8">
                  {isOpen && <motion.div id={contentId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.24,
                ease: 'easeInOut'
              }} data-id="element-61" data-mp="1pfq96yiaa7wt">
                      <p className="border-t border-brown-light/15 px-5 py-5 text-sm leading-relaxed text-[#4A4A4A] sm:px-7 sm:py-6 sm:text-base" data-id="element-62" data-mp="2r9rm1ub3svgf">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}